import React, { useEffect, useState } from "react";
import { Container, ContainerFluid } from "../../common/styles";
import CustomBreadCrumb from "../../components/breadcrumb";
import { NAV_LIST, TABS_ONBOARDING } from "./constant";
import {
    AddIcon,
    Button,
    Flex,
    Loader,
    ParticipantAddIcon,
} from "@fluentui/react-northstar";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { ROUTES } from "../../constants/routes";
import SubHeader from "../../components/breadcrumb/SubHeader";
import MainContentOnboarding from "./components/MainContentOnboarding";
import { _getAllAgencies } from "./api";
import { useQuery } from "react-query";
import withAuth from "../../HOC/withAuth";
import withRole from "../../HOC/withRole";
import { ROLES_CODE } from "../../constants/roles";

const NewOnboarding = () => {
    const navigate = useNavigate();

    const [tabView, setTabView] = useState(null);
    const [params, setParams] = useSearchParams();

    const param_tab = params.get("tab");

    useEffect(() => {
        if (param_tab) {
            setTabView(Number(param_tab));
        }
    }, []);

    const onChangeSliderTab = (value) => {
        setTabView(value);
        setParams({
            tab: value,
        });
        return;
    };

    const { isLoading, data: agencies } = useQuery(
        ["agencys"],
        () => _getAllAgencies(),
        {
            onSuccess: (data) => {
                if (!tabView && data) {
                    return setTabView(data[0]?.id);
                } else setTabView(tabView);
            },
            refetchOnWindowFocus: false,
        }
    );

    if (isLoading) {
        return <Loader label="Chargement de la page ....." />;
    }

    const menuItems = agencies?.map((agency) => ({
        content: agency.name,
        value: agency.id,
        action_count: agency?.action_count,
    }));

    return (
        <ContainerFluid fill column>
            <CustomBreadCrumb
                navList={NAV_LIST}
                actions={
                    <Button
                        content={"Ajouter un collaborateur"}
                        icon={<ParticipantAddIcon outline />}
                        iconPosition="after"
                        onClick={() =>
                            navigate(`${ROUTES.employee_add}?refer=onboarding`)
                        }
                        flat
                    />
                }
            />

            {agencies && (
                <Flex column>
                    <SubHeader
                        menu={menuItems}
                        setTabView={onChangeSliderTab}
                        defaultSelectedValue={tabView}
                        style={{
                            backgroundColor: "white",
                            // height: "56px",
                        }}
                    />

                    <Flex fill>
                        <MainContentOnboarding
                            AgencyId={tabView ?? param_tab}
                        />
                    </Flex>
                </Flex>
            )}
        </ContainerFluid>
    );
};

export default withAuth(withRole([ROLES_CODE.hr])(NewOnboarding));
